import axios from 'axios';
import { API } from './requests';
import { routeToLogin } from './utils';

let call;

export default function APICALLER(
	url,
	singleRequest,
	payload = {},
	method = API.METHOD.GET
) {
	try {
		const serviceHeader = {};
		const headers = { ...API.DEFAULT_HEADER, ...serviceHeader };
		if (singleRequest) {
			if (call) {
				call.cancel('cancel');
			}

			call = axios.CancelToken.source();
		}
		return axios({
			url,
			method,
			headers,
			data: payload,
			cancelToken: singleRequest ? call.token : null,
		})
			.then((response) => response)
			.catch((error) => {
				if (error?.response?.status === API.RESPONSE.UNAUTHORIZED) {
					routeToLogin();
				}
				return { error };
			});
	} catch (error) {
		return error;
	}
}
